import { render, staticRenderFns } from "./flight.vue?vue&type=template&id=536df6f9&scoped=true&"
import script from "./flight.vue?vue&type=script&lang=ts&"
export * from "./flight.vue?vue&type=script&lang=ts&"
import style0 from "./flight.vue?vue&type=style&index=0&id=536df6f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536df6f9",
  null
  
)

export default component.exports